// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import AlMulqaOvenCleaningPage from "../pages/AlMulqaOvenCleaning/AlMulqaOvenCleaning";
const __wvcRoutePaths = ["/AlMulqaOvenCleaningPage", "/\u062A\u0646\u0638\u064A\u0641-\u0623\u0641\u0631\u0627\u0646-\u062D\u064A-\u0627\u0644\u0645\u0644\u0642\u0627"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "almulqaovencleaningpage", "alnakheelovencleaningpage", "aristonovenmaintenanceriyadhpage", "blogpage", "contactuspage", "customerreviewspage", "gasovenmaintenanceriyadhpage", "homepage", "jasmineneighborhoodovencleaningpage", "ovencleaningalaqiqpage", "ovencleaningandwashingriyadhpage", "ovenmaintenanceriyadhpage", "post", "saudiceramicovenmaintenanceriyadhpage", "search", "servicespage", "\u0622\u0631\u0627\u0621-\u0627\u0644\u0639\u0645\u0644\u0627\u0621", "\u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629", "\u0627\u0644\u0645\u062f\u0648\u0646\u0629", "\u062a\u0646\u0638\u064a\u0641-\u0623\u0641\u0631\u0627\u0646-\u062d\u064a-\u0627\u0644\u0639\u0642\u064a\u0642", "\u062a\u0646\u0638\u064a\u0641-\u0623\u0641\u0631\u0627\u0646-\u062d\u064a-\u0627\u0644\u0645\u0644\u0642\u0627", "\u062a\u0646\u0638\u064a\u0641-\u0623\u0641\u0631\u0627\u0646-\u062d\u064a-\u0627\u0644\u0646\u062e\u064a\u0644", "\u062a\u0646\u0638\u064a\u0641-\u0623\u0641\u0631\u0627\u0646-\u062d\u064a-\u0627\u0644\u064a\u0627\u0633\u0645\u064a\u0646", "\u062a\u0646\u0638\u064a\u0641-\u0648\u063a\u0633\u064a\u0644-\u0627\u0644\u0623\u0641\u0631\u0627\u0646-\u0628\u0627\u0644\u0631\u064a\u0627\u0636", "\u062a\u0648\u0627\u0635\u0644-\u0645\u0639\u0646\u0627", "\u062e\u062f\u0645\u0627\u062a\u0646\u0627", "\u0635\u064a\u0627\u0646\u0629-\u0623\u0641\u0631\u0627\u0646-\u0623\u0631\u064a\u0633\u062a\u0648\u0646-\u0628\u0627\u0644\u0631\u064a\u0627\u0636", "\u0635\u064a\u0627\u0646\u0629-\u0623\u0641\u0631\u0627\u0646-\u0627\u0644\u062e\u0632\u0641-\u0627\u0644\u0633\u0639\u0648\u062f\u064a-\u0628\u0627\u0644\u0631\u064a\u0627\u0636", "\u0635\u064a\u0627\u0646\u0629-\u0627\u0644\u0623\u0641\u0631\u0627\u0646-\u0627\u0644\u063a\u0627\u0632\u064a\u0629-\u0628\u0627\u0644\u0631\u064a\u0627\u0636", "\u0635\u064a\u0627\u0646\u0629-\u0627\u0644\u0623\u0641\u0631\u0627\u0646-\u0628\u0627\u0644\u0631\u064a\u0627\u0636"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<AlMulqaOvenCleaningPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<AlMulqaOvenCleaningPage />} />
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
